import axios from 'axios';

class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    }

    this.selectors = {
      cartDrawerContainer: '#cart-drawer-container'
    }
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      }
    }
    window.dispatchEvent(new CustomEvent(event_name, contents))
  }

  add(data) {
    return new Promise((resolve, reject) => {
      this.request('add', data).then(({ data }) => {
        this.mergeWithCurrentCart(data)
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_added", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  get() {
    return new Promise((resolve, reject) => {
      this.request('get').then((response) => {
        this.cart = response.data;
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  update(data) {
    return new Promise((resolve, reject) => {
      this.request('update', data).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  remove(variant_id) {
    return new Promise((resolve, reject) => {
      let updates = {
        updates: {
          [variant_id]: 0,
        }
      }
      this.request('update', updates).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_removed", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    })
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.request('clear').then(({ data }) => {
        this.cart = data
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("cart_cleared", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  async request(key, data) {
    return new Promise((resolve, reject) => {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      axios({
        method,
        url,
        data,
        headers: {
          'Content-Type': 'application/json'
        },
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        if (error.response) {
          // Request made and server responded
          reject(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          reject(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error.message)
        }
      })
    })
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item)
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        })
        this.dispatchEvent("side_cart_closed", false)
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false)
    }
  }

  // Calls the seciton rendering API to render the v2-side-cart section (with refference to the cart page) and inserts the section html into the side cart
  async reRenderSideCart(successCallback = null) {
    await axios
      .get(window.Shopify.routes.root + "cart?sections=v2-side-cart", {})
      .then((response) => {
        // Success
        let html = response.data["v2-side-cart"];
        let side_cart_inner = document.querySelector(
          "#cart-drawer-container .inner"
        );

        if (side_cart_inner && html) {
          side_cart_inner.innerHTML = html;

          // Change free delivery status
          //let free_delivery_el = document.querySelector('.free-delivery-status');
          //let free_delivery_trigger = free_delivery_el.dataset.freeDelivery;
          // console.log("🚀 ~ file: side_cart_functions.js:59 ~ free_delivery_trigger", free_delivery_trigger)
          //let cart_total = document.querySelector('#cart-drawer .sub-total').dataset.subTotal / 100;

          // if (!free_delivery_trigger) {
          //   free_delivery_el.style.display = 'none';
          // } else if (cart_total < free_delivery_trigger) {
          //   let spend_more = free_delivery_trigger - cart_total;
          //   spend_more = spend_more.toFixed(2);
          //   free_delivery_el.innerHTML = `£${spend_more} away from free delivery`;
          // } else {
          //   free_delivery_el.innerHTML = `Yay! You've qualified for free delivery! 🎉`;
          // }

          let first_cart_item = side_cart_inner.querySelector('.item');

          if (first_cart_item) {
            first_cart_item = first_cart_item.dataset.productId;
          }

          // Get recommended products based on first item in side cart
          /*
          if (first_cart_item) {
            const productRecommendationsSection = document.querySelector('.cart-recommendations');
            const section_id = productRecommendationsSection.dataset.sectionId;

            // axios.get(`/recommendations/products.json?product_id=${first_cart_item}&limit=5`)
            axios.get(`/recommendations/products?section_id=${section_id}&product_id=${first_cart_item}&limit=5`, {})
              .then((response) => {
                const text = response.data;
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.cart-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  productRecommendationsSection.innerHTML = recommendations.innerHTML;
                  let product_links = productRecommendationsSection.querySelectorAll('.product-link');
                  product_links.forEach((product_link) => {
                    product_link.innerHTML = "View"
                  })

                  const swiper_side_cart_recommended = new window.swiper('.side-cart-recommendations-slider', {
                    slidesPerView: 2.4,
                    spaceBetween: 10,
                    breakpoints: {
                      1200: {
                        slidesPerView: 3.2
                      }
                    },
                    lazy: {
                      enabled: true,
                      checkInView: false,
                      loadOnTransitionStart: true,
                      loadPrevNext: true,
                      loadPrevNextAmount: 1
                    },
                  });

                }
              })
              .catch((error) => {
                window.log(error);
              })
          }
          */

          this.cartRenderedEvent(response, html)

          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        window.log("Error:", error);
      })
  }

  reRenderCart() {
    axios
      .get(window.Shopify.routes.root + "cart?sections=v2-cart-inner", {})
      .then(function (response) {
        let html = response.data["v2-cart-inner"];
        let cart_inner = document.querySelector("#cart-container .cart-inner");

        if (cart_inner && html) {
          cart_inner.innerHTML = html;
          this.cartRenderedEvent(response, html)
        }
      })
      .catch(function (error) {
        window.log("Error:", error);
      })
  }

  cartRenderedEvent(response, html) {
    window.dispatchEvent(new CustomEvent("cart_rendered", {
      detail: {
        response: response,
        html: html,
      },
    }));
  }
}

// export default new CartQf();
window.CartQf = CartQf;